// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--jOEle";